/** UI projection of actual workflow events; no guessed percentage or model reasoning. */
export interface QueryProgress {
  startedAt?: string; updatedAt?: string; activity: string; calls: number; terminal?: string;
}
export const queryProgress = (startedAt?: string): QueryProgress => ({ startedAt, activity: "等待检索与分析", calls: 0 });
const actions: Record<string, string> = {
  graph_search: "检索图谱", graph_expand: "沿图关系查找依据", graph_neighbors: "沿图关系查找依据",
  search: "检索材料", search_source: "检索材料", read_source: "读取原文依据", read: "读取任务规则",
  execute_plan: "执行图数据计算", query_state: "核对已读取依据", browse_directory: "浏览材料目录",
  read_directory: "读取材料目录", submit_analysis: "校验答案与引用",
  cite_source: "定位并保存原文引文", cite_calculation: "保存计算依据",
  save_hypothesis: "整理可能的解释", save_condition: "记录解释的成立条件",
  save_support: "关联支持依据", save_challenge: "关联相反依据", save_gap: "记录待补充材料",
  save_answer: "组织回答", analysis_state: "核对已保存的分析", remove_item: "修正已保存的分析",
  finish_analysis: "装配回答与溯源关系",
};
export function reduceQueryProgress(state: QueryProgress, event: Record<string, unknown>): QueryProgress {
  const data = event.data as Record<string, unknown> | undefined;
  const at = typeof event.occurred_at === "string" ? event.occurred_at : undefined;
  let activity = state.activity;
  if (event.type === "agent.tool") activity = actions[String(data?.tool)] ?? "检索并核对依据";
  if (event.stage === "hypothesis.draft") activity = data?.accepted === false
    ? "正在修正当前条目" : actions[String(data?.tool)] ?? "保存分析结果";
  if (event.type === "progress" && data?.activity === "provider.retry") activity = "接口暂时异常，正在重试";
  if (event.type === "progress" && data?.activity === "compaction_start") activity = "整理任务上下文";
  if (event.stage === "answer.draft") activity = "正在生成回答";
  if (event.stage === "answer.reset") activity = "正在核对并修正引用";
  return { ...state, startedAt: state.startedAt ?? at, updatedAt: at ?? state.updatedAt, activity,
    calls: Math.max(state.calls, typeof data?.calls === "number" ? data.calls : 0) };
}
